export function loginRememberMe(action) {
  return {
    type: action.type,
    data: {},
  }
}
